"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var Logo = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t", ";\n"], ["\n\t", ";\n"])), function (props) { return props.theme.brandLogo; });
var BrandLogo = /** @class */ (function (_super) {
    __extends(BrandLogo, _super);
    function BrandLogo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BrandLogo.prototype.render = function () {
        return (react_1.default.createElement(Logo, { className: this.props.className }, this.props.theme.svgs.brand_logo));
    };
    return BrandLogo;
}(react_1.Component));
exports.default = styled_components_1.withTheme(BrandLogo);
var templateObject_1;
//# sourceMappingURL=BrandLogo.js.map